import React from 'react';

import LazyHero from '@tmap/mmm-style-guide/src/LazyHero';

import buildImageObj from '../../lib/buildImageObj';
import { imageUrlFor } from '../../lib/image-url';

function Hero(props) {
  const {
    RecursiveComponent,
    isCentered = true,
    minHeight,
    parallaxOffset = 0,
    bannerImage,
    content,
    // eslint-disable-next-line react/destructuring-assignment
    opacity = props.color ? 0.7 : 0.0,
    color = '#fff',
  } = props;
  return (
    <LazyHero
      imageSrc={imageUrlFor(buildImageObj(bannerImage)).url()}
      color={color}
      opacity={opacity}
      isCentered={isCentered}
      minHeight={minHeight}
      parallaxOffset={parallaxOffset}
    >
      <RecursiveComponent value={content} />
    </LazyHero>
  );
}

export default Hero;
